import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import {clients} from "../../data/clientsData";
import '../partners/Partners.css';

const Clients: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <section className="partners-section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">{t('home.clients.title', 'Nos clients')}</h2>
          <p className="section-subtitle">{t('home.clients.subtitle', 'Approuvé par les leaders de l\'industrie à travers le Maroc')}</p>
        </motion.div>
        
        <div className="partners-grid">
          {clients.map((client, index) => (
            <motion.div
              className="partner-item"
              key={client.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="partner-logo">
                {client.url ? (
                  <a href={client.url} target="_blank" rel="noopener noreferrer" title={client.name}>
                    <img 
                      src={client.image}
                      alt={client.name}
                      title={client.name}
                    />
                  </a>
                ) : (
                  <img 
                    src={client.image}
                    alt={client.name}
                    title={client.name}
                  />
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
